import axios from 'axios'
import { store } from 'store/store'

import { defaultPublicKey } from 'utils/constants'

const axiosBase = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_PATH,
  timeout: 60000,
  withCredentials: true,
})

const axiosSlack = axios.create({
  baseURL: process.env.REACT_APP_SLACK_WEBHOOK_URL,
  timeout: 10000,
  withCredentials: false,
})

axiosBase.interceptors.request.use((config) => {
  const state = store.getState()
  const wizardSessionToken = config?.sessionToken
  const axiosConfig = {
    ...config,
    headers: {
      ...config.headers,
      'X-Crypto-Session-Token': wizardSessionToken || state?.app?.token,
    },
  }
  if (config.omitToken) {
    delete axiosConfig.headers['X-Crypto-Session-Token']
  }
  if (config.useDefaultPublicKey) {
    axiosConfig.headers.authorization = `BASIC ${state?.wizard?.publicKey ?? defaultPublicKey.publicKey}`
  }
  return axiosConfig
})

axiosSlack.interceptors.request.use((config) => {
  const axiosConfig = {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  }
  return axiosConfig
})

async function doRequest ({ method = 'get', url = '', payload = {}, config, completeResponse }) {
  try {
    const result = method === 'get' ?
      await axiosBase[method](url, config) :
      await axiosBase[method](url, payload, config)
    return completeResponse ? result : result.data
  } catch (error) {
    if (url.includes('/crypto/session/quote') && error?.response?.status <= 400) {
      return error
    } else {
      if (process.env.REACT_APP_BASE_URL_PATH === 'https://api.meld.io' && process.env.REACT_APP_SLACK_WEBHOOK_URL) {
        const apiPayload = {
          method: error?.response?.config?.method?.toUpperCase() || '',
          endpoint: `${process.env.REACT_APP_BASE_URL_PATH}${error?.response?.config?.url}`,
          requestId: error?.response.headers['x-request-id'] || '-',
          payload: payload,
          response: error?.response?.data?.message || error?.request || error?.message,
          statusCode: error?.response?.status || '',
        }
        const slackPayload = {
          attachments: [
            {
              color: 'danger',
              pretext: `❌ API Failure  |  Request Id: ${apiPayload.requestId}`,
              text: `*Status Code:* ${apiPayload.statusCode}  |  *Method:* ${apiPayload.method}`,
              fields: [
                {
                  title: 'Endpoint',
                  value: apiPayload.endpoint,
                  short: false,
                },
                {
                  title: 'Payload',
                  value: JSON.stringify(apiPayload.payload),
                  short: false,
                },
                {
                  title: 'API Response',
                  value: JSON.stringify(apiPayload.response),
                  short: false,
                },
              ],
            },
          ],
        }
        await axiosSlack.post('', slackPayload)
      }
    }
    return error
  }
}

export default doRequest
